import React, { useEffect, useState } from 'react';

import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/pagination';

import { Pagination } from 'swiper/modules';
import { Slide } from './slide';
import { slides } from './constants';

export const HighlightsBlock = () => {
  const [swiper, setSwiper] = useState();
  const [expanded, setExpanded] = useState(false);

  const handleExpand = () => {
    setExpanded((prev) => !prev);
  }

  const handleNext = () => {
    swiper?.slideNext();
  }

  useEffect(() => {
    swiper?.updateAutoHeight(300);
  }, [expanded, swiper]);

  return (
    <div style={{background: 'white', color: '#25242D', display: 'flex', flexDirection: 'column', gap: '19px'}}>
      <div style={{fontSize: '32px', marginTop: '30px', textAlign: 'left', padding: '0px 24px 24px'}}>
        <div style={{paddingBottom: '14px', borderBottom: '1px solid black'}}>
          Highlights
        </div>
      </div>
      <div className={expanded ? 'expanded' : ''}>
        <Swiper pagination={true} modules={[Pagination]} className="mySwiper" onSwiper={(swiper) => setSwiper(swiper)} loop={true} autoHeight={true}>
            {slides.map(({img, title, afterTitleText, expandText, href}, index) => (
              <SwiperSlide>
                <Slide
                  key={index}
                  onNext={handleNext}
                  img={img}
                  title={title}
                  afterTitleText={afterTitleText}
                  expandText={expandText}
                  expanded={expanded}
                  onClick={handleExpand}
                  href={href}
                />
              </SwiperSlide>
            ))}
        </Swiper>
      </div>
    </div>
  );
}